<template>
  <v-container>
    <v-row>
      <v-col class="text-h6 pt-0">
        Create New Alert
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-container>
          <v-row>
            <v-col class="text-center">
              <v-btn
                outlined
                color="primary"
                x-large
                @click="handleClickTripwires"
                @mouseover="btnHover = 'tripwires'"
                @mouseout="btnHover = null"
                >Tripwires</v-btn
              >

              <v-btn
                outlined
                color="primary"
                x-large
                class="ml-6 mr-3"
                @click="handleClickSearches"
                @mouseover="btnHover = 'savedqueries'"
                @mouseout="btnHover = null"
                >{{ searchesBtnText }}</v-btn
              >

              <v-btn
                outlined
                color="primary"
                x-large
                class="ml-3 mr-6"
                @click="handleClickBriefings"
                @mouseover="btnHover = 'briefings'"
                @mouseout="btnHover = null"
                >Expert Analysis <br />&amp; Outlooks</v-btn
              >

              <v-btn
                outlined
                color="primary"
                x-large
                @click="handleClickAssets"
                @mouseover="btnHover = 'assets'"
                @mouseout="btnHover = null"
                >Assets</v-btn
              >
            </v-col>
          </v-row>

          <v-row>
            <v-col class="text-center" style="height: 20px;">
              <div v-show="btnHover === 'tripwires'" class="btn-text-container">
                <span class="application-heading">Tripwires:</span> Setup alerts
                for Hotspots by location and/or type; and sign up to be notified
                of changes to Pulse, Risk Rating and Evacuation indicators.
              </div>
              <div
                v-show="btnHover === 'savedqueries'"
                class="btn-text-container"
              >
                <span class="application-heading">Custom Searches:</span> Set up
                alerts for AI-distilled or human verified events, news, social
                or analysis. Note: takes you to our Search tool to set up custom
                searches using a keyword builder, location filter and selectors
                for targeted results.
              </div>
              <div v-show="btnHover === 'briefings'" class="btn-text-container">
                <span class="application-heading"
                  >Expert Analysis &amp; Outlooks:</span
                >
                Sign up for forward-looking periodic analytical reports, curated
                by our experts.
              </div>
              <div v-show="btnHover === 'assets'" class="btn-text-container">
                <span class="application-heading">Assets:</span> Set up
                proximity alerts that match your monitoring requirements around
                your assets.
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { MODULE_PREFIX_HOME } from "@/store";
import { GET_SELECTOR_PANEL } from "@/store/actions.type";
import {
  EVENT_ACTIONS,
  ALERTSV2_CATEGORIES,
} from "@/common/constants/analytics";

const EMITTED_ACTIONS = {
  CLICK_TRIPWIRES: "click-tripwires",
  CLICK_SEARCHES: "click-searches",
  CLICK_BRIEFINGS: "click-briefings",
  CLICK_ASSETS: "click-assets",
};

export default {
  name: "NotificationsStepCreateNew",
  data: function () {
    return {
      btnHover: null,
    };
  },
  computed: {
    searchesBtnText() {
      return "Custom searches";
    },
  },
  methods: {
    handleClickTripwires() {
      this.$emit(EMITTED_ACTIONS.CLICK_TRIPWIRES);
      this.handlePageTrackerEvent(
        ALERTSV2_CATEGORIES.alertsv2,
        EVENT_ACTIONS.clicked,
        "Tripwire Button"
      );
    },
    handleClickSearches() {
      this.$emit(EMITTED_ACTIONS.CLICK_SEARCHES);
      this.handlePageTrackerEvent(
        ALERTSV2_CATEGORIES.alertsv2,
        EVENT_ACTIONS.clicked,
        "Searches Button"
      );
    },
    handleClickBriefings() {
      this.$emit(EMITTED_ACTIONS.CLICK_BRIEFINGS);
      this.handlePageTrackerEvent(
        ALERTSV2_CATEGORIES.alertsv2,
        EVENT_ACTIONS.clicked,
        "Expert Analysis & Outlooks Button"
      );
    },
    handleClickAssets() {
      this.$emit(EMITTED_ACTIONS.CLICK_ASSETS);
      this.handlePageTrackerEvent(
        ALERTSV2_CATEGORIES.alertsv2,
        EVENT_ACTIONS.clicked,
        "Assets Button"
      );
    },
  },
};
</script>

<style scoped>
.btn-text-container {
  width: 475px;
  margin: 0 auto;
}
</style>
